import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { banco } from './../../shared/object/banco.model';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: 'app-banco',
  templateUrl: './banco.component.html',
  styleUrls: ['./banco.component.scss'],
  providers: [SecurityService, ValidadoresService]
})
export class BancoComponent implements OnInit {
  private client: GraphQLClient = null;
  formulario: FormGroup;
  bancoList: banco[];
  selectedBanco: banco;
  banco: banco;
  public nombre:string;
  public codigo:number;
  @ViewChild('agregarBanco', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarBanco', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 9;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());

  constructor(client: GraphQLClient,
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService 
    ){
    this.client = client;
    this.buildForm();
  }

  buildForm() {
    this.formulario = this.formBuilder.group({
      codigo: [''],
      nombre: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      activado: [true]
    });
  }

  ngOnInit() {
    this.selectedBanco = {
      codigo: null,
      nombre: '',
      activado:true
    };
    this.obtenerDatosBanco();
  }

  obtenerDatosBanco() {
    let self = this; 
    this.client.query({
      query: gql`
      query{
        banco{
          obtenerTodos{
            respuesta{
              registros{
                codigo
                nombre
                activado
              }
            }
          }
        }
      }
      `,
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      self.bancoList = respuesta.data.banco.obtenerTodos.respuesta.registros;
    });
  }

  showNew() {
    this.formulario.reset();
    this.formulario.get('nombre').enable();
    this.formulario.get('activado').setValue(true);
  }

  insertar() {
    this.selectedBanco.nombre = this.formulario.controls["nombre"].value;
    this.postBanco(this.selectedBanco);
  }

  postBanco(banco:banco) {
    let self = this;
    var bodyx = banco;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: bancoInputType)
      {
        banco
        {
          agregar(entidad: $entidad) {
            respuesta{
              codigo
              nombre
              activado
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.banco.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosBanco(), 1000);
        }
      });
  }

  showForEdit(banco: banco) {
    this.codigo = banco.codigo;
    this.formulario.get('codigo').setValue(banco.codigo);
    this.formulario.get('nombre').setValue(banco.nombre);
    this.formulario.get('activado').setValue(banco.activado);
  }


  actualizar() {
    this.selectedBanco.codigo = this.formulario.controls["codigo"].value;
    this.selectedBanco.nombre = this.formulario.controls["nombre"].value;
    this.selectedBanco.activado = this.formulario.controls["activado"].value;
    this.refrescar(this.selectedBanco);
  }

  refrescar(banco: banco) {
    let self = this;
    var bodyx = banco;
    delete banco["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad: bancoInputType)
      {
        banco
        {
          modificar(entidad: $entidad) {
            respuesta{
              codigo
              nombre
              activado
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.banco.modificar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosBanco(), 1000);
        }
      });
  }

  cambiaEstado(banco:banco)
  {
    if (banco.activado)
    {
      banco.activado = false; 
    }
    else
    {
      banco.activado = true;
    }
    this.refrescar(banco);
  }

  obtenerDatosSegunFiltro(filtro_nombre:string) {
    let self = this;
    self.selectedBanco = {
      codigo: null,
      nombre: '',
      activado:true
    };
    var bodyx = self.selectedBanco;
    if (filtro_nombre != undefined){
      bodyx.nombre = filtro_nombre;
    }
    this.client.mutate({
      mutation: gql`
      query ($entidad:bancoInputType){
        banco{
          obtenerSegunFiltro(filtro:{
            exacto:$entidad
          })
          {
            respuesta
            {
              registros
              {
                codigo
                nombre
                activado
              }
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        self.bancoList = respuesta.data.banco.obtenerSegunFiltro.respuesta.registros;
      });
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(banco:banco) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(banco);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
 
}
